// extracted by mini-css-extract-plugin
export default {"button":"fgHLUq","container":"GcE_Hs","mobile":"uKkRtb","loader":"ROSx2b"};